<template>
  <div>
    <Modal
        v-show="isModalVisible"
        :constat="flux.constat"
        :type="flux.level2"
        @close="closeModal"
        @edit="editRepair"
        @evenement="evenement"
    />
    <v-row>
      <v-col cols="12">
        <h2 class="mt10 pt10">PRESSION / SCRATCH / ŒILLET</h2>
        <div class="spacer"></div>
        <div>
          <b>Choisissez le type de réparation que vous souhaitez</b>
        </div>
        <div class="spacer"></div>
        <v-tabs
            v-model="active_tab"
            next-icon="mdi-arrow-right-bold-box-outline"
            prev-icon="mdi-arrow-left-bold-box-outline"
            show-arrows
            @change="onChangeTab"
        >
          <v-tab href="#pression">
            PRESSION
          </v-tab>
          <v-tab href="#scratch">
            SCRATCH
          </v-tab>
          <v-tab href="#oeillet">
            ŒILLET
          </v-tab>

          <v-tab-item id="pression">
            <KeepAlive>
              <component v-bind:is="flux.activeTab" @evenement="evenement" @showmodal="showModal"></component>
            </KeepAlive>
          </v-tab-item>
          <v-tab-item id="scratch">
            <KeepAlive>
              <component v-bind:is="flux.activeTab" @evenement="evenement" @showmodal="showModal"></component>
            </KeepAlive>
          </v-tab-item>
          <v-tab-item id="oeillet">
            <KeepAlive>
              <component v-bind:is="flux.activeTab" @evenement="evenement" @showmodal="showModal"></component>
            </KeepAlive>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {mapMutations, mapState} from 'vuex'
import Modal from '../Modal.vue';


export default {
  name: 'PressionScratchOeillet',
  data() {
    return {
      tabName: null,
      isModalVisible: false
    }
  },
  computed: {
    ...mapState('cart-app', ['cards', 'products']),
    ...mapState('flux-app', ['flux']),
    active_tab: {
      get() {
        return this.flux.activeTab
      },
      set(newValue) {
        this.setActiveTab(newValue)
      }
    }
  },
  methods: {
    ...mapMutations('flux-app', ['setConstat', 'setCptProduct', 'setcptReparation', 'setActiveTab']),
    ...mapMutations('cart-app', ['addProduct', 'getTotalCart']),
    onChangeTab(value) {
      this.tabName = value
      this.setActiveTab(value)
    },
    editRepair(indexes) {
      this.$emit('edit', indexes)
    },
    evenement($value) {
      this.$emit('evenement', $value)
    },
    showModal() {
      this.$emit('showmodal', this.flux.level2)
    },
    closeModal() {
      this.isModalVisible = false;
    }
  },
  components: {
    Modal,
    pression: () => import('./pression.vue'),
    scratch: () => import('./scratch.vue'),
    oeillet: () => import('./oeillet.vue'),
  }
}
</script>
